<template>
  <div>
    <div class="card">
      <div class="card-title border-bottom p-3 mb-0 header-title">
        {{$t('common.upload_resume.steps.step4.education_background')}}
        <a 
          href="#"
          @click="showEd = true"
          class="btn btn-primary btn-sm btn-rounded float-right">
          <i class="uil-plus"></i>
        </a>
      </div>
      <div class="card-body">
        <VuePerfectScrollbar style="max-height: 300px">
          <div 
            class="text-center"
            v-if="model.education_background.length == 0"
            >No education found.</div>

          <div class="list-group"
            v-for="item in model.education_background"
            :key="`item-${item.uiid}`">
            <div class="list-group-item mb-2">
              <div>
                <h5 class="font-size-15 m-0">{{ item.school  }} {{ item.school_type | capitalize}}
                  <a href="#"
                    @click="removeEducationBackground( item.uiid )"
                    class="btn btn-danger btn-sm btn-rounded float-right ml-1">
                    <i class="uil-trash"></i>
                  </a>
                  <a 
                    href="#"
                    @click="editEducationBackground( item.uiid  )"
                    class="btn btn-primary btn-sm btn-rounded float-right">
                    <i class="uil-pen"></i>
                  </a>
                </h5>
                <p class="m-0">{{ item.degree }}</p>
                <p class="text-muted mb-1">{{ item.start_year }} - {{ item.end_year }}</p>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
    <b-modal 
      v-model="showEd" 
      size="lg" 
      ref="education"
      :title="(education.uiid ? 'Edit' : 'Add') + ' Education'" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step4.window_education.school.placeholder')"
            :label="$t('common.upload_resume.steps.step4.window_education.school.label')"
            v-model="education.school"
          />
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step4.window_education.degree.placeholder')"
            :label="$t('common.upload_resume.steps.step4.window_education.degree.label')"
            v-model="education.degree"
          />
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step4.window_education.field_of_study.placeholder')"
            :label="$t('common.upload_resume.steps.step4.window_education.field_of_study.label')"
            v-model="education.field_of_study"
          />
          <div class="row">
            <TextField 
              type="number"
              :placeholder="$t('common.upload_resume.steps.step4.window_education.start_year.placeholder')"
              :label="$t('common.upload_resume.steps.step4.window_education.start_year.label')"
              v-model="education.start_year"
              class="col-md-6"
            />
            <TextField 
              type="number"
              :placeholder="$t('common.upload_resume.steps.step4.window_education.end_year.placeholder')"
              :label="$t('common.upload_resume.steps.step4.window_education.end_year.label')"
              v-model="education.end_year"
              class="col-md-6"
            />
          </div>
          <textarea
            class="form-control"
            rows="7"
            :placeholder="$t('common.upload_resume.steps.step4.window_education.description.placeholder')"
            v-model="education.description"></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="education.uiid" @click="removeEducationBackground">Remove</b-button>
        <b-button variant="light" @click="showEd = false">Close</b-button>
        <b-button variant="primary" @click="addEducationBackground">{{ ( education.uiid ? 'Update' : 'Add') + ' Education' }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import TextField from '@components/form/textfield.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        education_background:[],
      },
      showEd:false,
      education:{},
      month_options : [
        { value: null, text: '-' },
        { value:'january', text:'January'},
        { value:'february', text:'February'},
        { value:'march', text:'March'},
        { value:'april', text:'April'},
        { value:'may', text:'May'},
        { value:'june', text:'June'},
        { value:'july', text:'July'},
        { value:'august', text:'August'},
        { value:'september', text:'September'},
        { value:'october', text:'October'},
        { value:'november', text:'November'},
        { value:'december', text:'December'}
      ],
    }
  },
  components:{TextField, VuePerfectScrollbar},
  methods: {
    ...mapActions('prospect', [
      'createEducation', 
      'removeEducation',
      'updateEducation',
    ]),
    async validate() {
      var isValid = true

      
      this.$emit('on-validate', null, isValid)
      return isValid
    },
    addEducationBackground(){
      delete this.education._idx

      if(!this.education.uiid){
        this.education.candidate_id = this.$route.query.id
        this.createEducation(this.education).then(res => {
          this.model.education_background.push(res.data)
        })
      }else{
        this.updateEducation(this.education).then(res => {
          this.education = res;
        })
      }
      this.education = {}
      this.showEd = false
    },
    editEducationBackground(uiid){

      this.model.education_background.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.education = el
          this.education._idx = idx
          //this.model.educations.splice(idx, 1)
        }
        return false
      });
      this.$refs['education'].show()

    },
    removeEducationBackground(uiid){
      if(!this.education.uiid){
        this.model.education_background.forEach((el, idx) => {
          if(el.uiid == uiid){
            this.education = el
            this.education._idx = idx
            //this.model.education_background.splice(idx, 1)
          }
          return false
        });
      }
      this.removeEducation(this.model.education_background[this.education._idx]).then(res => {
        if(res.data.ok == 1){
          this.model.education_background.splice(this.education._idx, 1)
          this.education = {}
          this.$refs['education'].hide()
        }else{
          alert('Please try again')
        }
      })
    },
  },
  props:['data'],
  watch: { 
    data: function(newVal) { // watch it
      this.model.education_background = newVal
    }
  }
}
</script>